<template>
    <DashboadCard :borderColor="borderColor" :backgroundColor="backgroundColor">
        <div class="stat-card">
            <div class="stat-card__header">
                <DashboardIcon :icon="icon" :color="color" />
                <div class="stat-card__texts">
                    <div class="stat-card__label">{{ label }}</div>
                    <div class="stat-card__sublabel">{{ sublabel }}</div>
                </div>
            </div>
            <div class="stat-card__percentage-container">
                <div class="stat-card__percentage">{{ value }}{{ suffix }}</div>
                <div v-if="detail" class="stat-card__detail">{{ detail }}</div>
            </div>
            <div v-if="showProgress" class="stat-card__progress">
                <div class="stat-card__progress-bar" :style="{ width: value + '%', backgroundColor: color }"></div>
            </div>
        </div>
    </DashboadCard>
</template>

<script>
import DashboadCard from './DashboadCard.vue';
import DashboardIcon from './DashboardIcon.vue';
import { applyTransparency } from '@/utils/helpers';

export default {
    name: 'StatCard',
    components: {
        DashboadCard,
        DashboardIcon
    },
    props: {
        icon: {
            type: String,
            required: true
        },
        label: {
            type: String,
            required: true
        },
        sublabel: {
            type: String,
            required: true
        },
        value: {
            type: [Number, String],
            required: true
        },
        suffix: {
            type: String,
            default: '%'
        },
        detail: {
            type: String,
            default: ''
        },
        showProgress: {
            type: Boolean,
            default: true
        },
        color: {
            type: String,
            default: '#dce2e8'
        },
        applyBgColor: {
            type: Boolean,
            default: false
        },
        applyBorderColor: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        backgroundColor() {
            return this.applyBgColor ? applyTransparency(this.color, 0.1) : '#ffffff';
        },
        borderColor() {
            return this.applyBorderColor ? applyTransparency(this.color, 0.3) : '#dce2e8';
        }
    }
}
</script>

<style scoped>
.stat-card {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
}

.stat-card__percentage-container {
    display: flex;
    align-items: flex-end;
    gap: 0.5rem;
}

.stat-card__header {
    display: flex;
    align-items: center;
    gap: 0.75rem;
}

.stat-card__texts {
    display: flex;
    flex-direction: column;
    gap: 0.1rem;
}

.stat-card__label {
    font-size: 0.95rem;
    font-weight: 600;
    color: var(--foreground);
}

.stat-card__sublabel {
    font-size: 0.8rem;
    color: var(--foreground);
    opacity: 0.6;
}

.stat-card__percentage {
    font-size: 2rem;
    font-weight: 700;
    margin: 0.5rem 0 0.25rem;
    margin-bottom: -2px;
}

.stat-card__detail {
    font-size: 0.85rem;
    color: var(--foreground);
    opacity: 0.7;
    margin-bottom: 0.25rem;
}

.stat-card__progress {
    width: 100%;
    height: 6px;
    background-color: rgba(0, 0, 0, 0.08);
    border-radius: 3px;
    overflow: hidden;
    margin-top: 0.25rem;
}

.stat-card__progress-bar {
    height: 100%;
    border-radius: 3px;
    transition: width 0.6s ease;
}
</style>
